import React from 'react';

import { SVGComponentProps } from './svg.types';

const AiClearButtonSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="13"
        height="9"
        viewBox="0 0 13 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M4.35227 9L0.0142046 4.63636L4.35227 0.272727H12.5V9H4.35227ZM4.80824 7.90909H11.4091V1.36364H4.80824L1.55256 4.63636L4.80824 7.90909ZM9.88778 6.40909L9.15483 7.15909L4.82528 2.86364L5.55824 2.11364L9.88778 6.40909ZM5.55824 7.15909L4.82528 6.40909L9.15483 2.11364L9.88778 2.86364L5.55824 7.15909Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AiClearButtonSVG;
